import { all, call, put, takeLatest } from 'redux-saga/effects';
import { push } from 'redux-first-history';
import { generatePath } from 'react-router';

import api from '@api';
import { createSerie, deleteSerie, fetchSerieList, updateSerie } from './serie.actions';
import { LoadersNames } from '../../ui/ui.actions';
import { uiActions } from '../../actions';
import { putError, putWarning } from '@utils/notificationUtils';
import { SerieRoutePaths } from '@routes/routesPaths';

export function* serieListSaga() {
  yield put(uiActions.showLoader(LoadersNames.fetchingData));
  try {
    const result = yield call(api.serie.serieListQuery);
    yield put(fetchSerieList.done({ params: {}, result }));
  } catch (err) {
    yield putError(err, 'app:msg_title_error', 'app:error_getting_serie_list');
  }
  yield put(uiActions.hideLoader(LoadersNames.fetchingData));
}

export function* createSerieSaga({ payload }: ReturnType<typeof createSerie.started>) {
  yield put(uiActions.showLoader(LoadersNames.fetchingData));
  try {
    const result = yield call(api.serie.createSerieMutation, payload);
    yield put(createSerie.done({ params: payload, result }));
    yield put(push(SerieRoutePaths.serieRoot));
  } catch (err) {
    yield putError(err, 'app:msg_title_error', 'app:error_creating_serie');
  }
  yield put(uiActions.hideLoader(LoadersNames.fetchingData));
}

export function* updateSerieSaga({ payload }: ReturnType<typeof updateSerie.started>) {
  yield put(uiActions.showLoader(LoadersNames.fetchingData));
  try {
    const result = yield call(api.serie.updateSerieMutation, payload);
    yield put(updateSerie.done({ params: payload, result }));
    yield put(push(generatePath(SerieRoutePaths.serieRoot)));
  } catch (err) {
    yield putError(err, 'app:msg_title_error', 'app:error_updating_serie');
  }
  yield put(uiActions.hideLoader(LoadersNames.fetchingData));
}

export function* deleteSerieSaga({ payload }: ReturnType<typeof deleteSerie.started>) {
  yield put(uiActions.showLoader(LoadersNames.fetchingData));
  try {
    const result = yield call(api.serie.deleteSerieMutation, payload);
    yield put(deleteSerie.done({ params: payload, result }));
    yield put(push(SerieRoutePaths.serieRoot));
    yield putWarning('app:msg_title_deleted', 'app:msg_serie_deleted');
  } catch (err) {
    yield putError(err, 'app:msg_title_error', 'app:error_deleting_serie');
  }
  yield put(uiActions.hideLoader(LoadersNames.fetchingData));
}

export function* watchSerieSaga() {
  yield all([
    yield takeLatest(fetchSerieList.started, serieListSaga),
    yield takeLatest(createSerie.started, createSerieSaga),
    yield takeLatest(updateSerie.started, updateSerieSaga),
    yield takeLatest(deleteSerie.started, deleteSerieSaga),
  ]);
}
